import { TType } from '../../hooks/useTranslation';

export const returnRadioButtons = (t: TType, isep: boolean, setIsep) => [
  {
    id: 'yes-radio',
    label: t('common.yes'),
    value: '1',
    onChange: () => setIsep(true),
    checked: isep,
  },
  {
    id: 'no-radio',
    label: t('common.no'),
    value: '0',
    onChange: () => setIsep(false),
    checked: !isep,
  },
];
